import { Star, MessageSquare } from 'lucide-react'
import { useEffect, useState } from 'react'
import { API_URL } from '../../config/api'

interface Props {
  agentId: number
}

export default function AgentReviewsTab({ agentId }: Props) {
  const [peerReviews, setPeerReviews] = useState<any[]>([])
  const [feedback, setFeedback] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    const headers: Record<string, string> = token ? { Authorization: `Bearer ${token}` } : {}
    Promise.all([
      fetch(`${API_URL}/api/agents/${agentId}/peer-reviews`, { headers }).then(r => r.ok ? r.json() : { reviews: [] }).catch(() => ({ reviews: [] })),
      fetch(`${API_URL}/api/agents/${agentId}/feedback`, { headers }).then(r => r.ok ? r.json() : { feedback: [] }).catch(() => ({ feedback: [] })),
    ]).then(([pr, fb]) => {
      setPeerReviews(pr.reviews ?? [])
      setFeedback(fb.feedback ?? [])
      setLoading(false)
    })
  }, [agentId])

  if (loading) return <div className="ad-loading">Loading reviews...</div>

  const hasContent = peerReviews.length > 0 || feedback.length > 0

  if (!hasContent) return (
    <div className="ad-empty"><Star size={32} /><p>No reviews yet</p></div>
  )

  return (
    <div className="ad-reviews">
      {/* Peer Reviews */}
      {peerReviews.length > 0 && (
        <div className="ad-review-section">
          <h4 className="ad-review-section-title"><Star size={14} /> Peer Reviews</h4>
          {peerReviews.slice(0, 10).map((r, i) => (
            <div key={r.id ?? i} className="ad-review-row">
              <div className="ad-review-score">{r.score ?? r.rating}/5</div>
              <div className="ad-review-body">
                <div className="ad-review-comment">{r.comment ?? 'No comment'}</div>
                <div className="ad-review-meta">
                  {r.reviewer_name && <span>by {r.reviewer_name}</span>}
                  {r.created_at && <span>{new Date(r.created_at).toLocaleDateString()}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* User Feedback */}
      {feedback.length > 0 && (
        <div className="ad-review-section">
          <h4 className="ad-review-section-title"><MessageSquare size={14} /> User Feedback</h4>
          {feedback.slice(0, 10).map((f, i) => (
            <div key={f.id ?? i} className="ad-review-row">
              <div className="ad-review-score">{f.user_rating ?? f.rating}/5</div>
              <div className="ad-review-body">
                <div className="ad-review-comment">{f.comment ?? 'No comment'}</div>
                <div className="ad-review-meta">
                  {f.created_at && <span>{new Date(f.created_at).toLocaleDateString()}</span>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
